$(document).ready(function(){

	// -- Hamburger --
	$('.hamburger').on('click', function(){
		$('body').toggleClass('mobileMenu--open');
		$(this).toggleClass('is-active');
	});

	// -- Close mobile menu when click
	$('.main__nav li a:not(.dropdown-toggle)').on('click', function(){
		$('body').removeClass('mobileMenu--open');
		$('.hamburger').removeClass('is-active');
	});

	// -- Dropdown --
	$(document).on('click', '.dropdown-toggle', function(e){
		e.preventDefault();		
		if (!$(this).parent('.dropdown').hasClass('open')) {
			$('.dropdown').removeClass('open');
			$(this).parent('.dropdown').toggleClass('open');
		} else {
			$('.dropdown').removeClass('open');
		}
	});

	// -- Close dropdown when click outside --
	$(document).on('mouseup', function(e) {
	  var container = $('.dropdown');
	  if (!container.is(e.target) && container.has(e.target).length === 0) {
			$('.dropdown').removeClass('open');
	  }
	});

	// -- Close dropdown on mouseleave --
	var closeDropdownMenu; // global
	$('.main__nav').on('mouseleave', '.dropdown-menu', function(){
		closeDropdownMenu = setTimeout(function(){
			$('.dropdown').removeClass('open');
		},3000);
	});

	// -- Clear timeout to prevent close dropdown on mouseenter --
	$('.main__nav').on('mouseenter', '.dropdown-menu', function(){
		clearTimeout(closeDropdownMenu);
	});

	// -- Hide header on scroll down but show header on scroll up --
	var didScroll;
	var lastScrollTop = 0;
	var delta = 5;
	var navbarHeight = $('.header').outerHeight();

	$(window).scroll(function(event){
		var st = $(this).scrollTop();
		if (st > navbarHeight) {
    	didScroll = true;
		}
	});

	setInterval(function() {
		if (didScroll) {
			hasScrolled();
			didScroll = false;
		}
	}, 250);

	function hasScrolled() {
		var st = $(this).scrollTop();
		// Make sure they scroll more than delta
		if(Math.abs(lastScrollTop - st) <= delta) {
			return;
		}
		// If they scrolled down and are past the navbar, add class .nav-up.
		// This is necessary so you never see what is "behind" the navbar.
		if (st > lastScrollTop && st > navbarHeight){
		  // Scroll Down
		  $('body').removeClass('header--fixed');
		} else {
		  // Scroll Up
		  if(st + $(window).height() < $(document).height()) {
		  	$('body').addClass('header--fixed');
		  }
		}
		lastScrollTop = st;
	}

});



// $(document).on('scroll resize orientationchange', function(){
// 	// -- Header fixed --
// 	var scrollTop = $(this).scrollTop();
// 	var header = $('.header').outerHeight();
// 	if (scrollTop > header) {
// 		$('body').addClass('header--fixed');
// 	} else {
// 		$('body').removeClass('header--fixed');
// 	}

// });